import script from "./theater.vue?vue&type=script&setup=true&lang=js"
export * from "./theater.vue?vue&type=script&setup=true&lang=js"

import "./theater.vue?vue&type=style&index=0&id=7b9e2744&lang=less&scoped=true"
import "./theater.vue?vue&type=style&index=1&id=7b9e2744&lang=less"

import exportComponent from "D:\\CODE\\joyjobs_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b9e2744"]])

export default __exports__